import { render, staticRenderFns } from "./youhuiquan.vue?vue&type=template&id=5602a928&scoped=true&"
import script from "./youhuiquan.vue?vue&type=script&lang=js&"
export * from "./youhuiquan.vue?vue&type=script&lang=js&"
import style0 from "./youhuiquan.scss?vue&type=style&index=0&id=5602a928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5602a928",
  null
  
)

export default component.exports